import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../environments/environment'
import { LocalStorage } from '@ngx-pwa/local-storage'
import { User } from '../models/user'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http: HttpClient) { }

  search<T>(value: string): Observable<T> {
    return this.http.get<T>(environment.api + '/users/search/'+value+'?limit=100&attributes=id,follower_count,following_count,email,location,first_name,last_name,privacy_profile,fb_identifier,created_at,profile_image_url', {
      headers: {
        'Authorization': 'Bearer ' + window.localStorage.getItem("auth_token")
      }
    })
  }

  adminUsers(): Observable<User[]> {
    return this.http.get<User[]>(environment.api + '/admin/users', {
      headers: {
        'Authorization': 'Bearer ' + window.localStorage.getItem("auth_token")
      }
    })
  }

  toggleUserStatus(user_id: string): Observable<User> {
    return this.http.put<User>(environment.api + '/admin/user/' + user_id, {}, {
      headers: {
        'Authorization': 'Bearer ' + window.localStorage.getItem("auth_token")
      }
    })
  }
}